// M12 - MotricityEventScatter
//
// Scatter plot 2D generico para mostrar eventos posicionados (p.ej.
// buzzes XYZ proyectados a top-down XZ). Util para detectar patrones
// espaciales en los errores del paciente.

import React, { useMemo } from "react";
import { Card, Empty } from "antd";
import { useTranslation } from "react-i18next";
import { Scatter } from "@ant-design/charts";

export function MotricityEventScatter({
  title,
  points, // [{ x, y, label? }]
  xLabel = "X",
  yLabel = "Y",
  height = 320,
  color = "#c63f3e",
}) {
  // El titulo y las etiquetas de los ejes los pone quien monta la grafica;
  // aqui solo se traduce el texto propio del componente.
  const { t } = useTranslation("motricity");

  const data = useMemo(
    () =>
      (points || []).map((p) => ({
        x: Number(p.x) || 0,
        y: Number(p.y) || 0,
        label: p.label || "",
      })),
    [points],
  );

  const config = useMemo(
    () => ({
      data,
      xField: "x",
      yField: "y",
      height,
      autoFit: true,
      colorField: () => "point",
      color,
      size: 6,
      shape: "circle",
      pointStyle: { fillOpacity: 0.7 },
      axis: { x: { title: xLabel }, y: { title: yLabel } },
    }),
    [data, height, xLabel, yLabel, color],
  );

  return (
    <Card title={title} variant="outlined">
      {data.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={t("charts.scatter.empty")}
        />
      ) : (
        <Scatter {...config} />
      )}
    </Card>
  );
}
